import { ca } from '@cian/analytics';

import { IBrokerAnalyticsUser } from './types';
import { TJsonQuery } from '../../../../packages/JsonQuery';

export const trackBannerClick = (sc: TJsonQuery, user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'BrokerDealBanner',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
    },
    user,
  });
};
